import Cell from './cell';
import Dimension from './dimension';

/**
 * @class Composite
 */
export default class Composite {
    /**
     * @param {Cell} cell
     * @param {Dimension} dimension
     * @constructor
     */
    constructor(cell, dimension) {
        if (!(cell instanceof Cell)) {
            throw new Error('Composite() - Cell value has to be of type Cell');
        }
        if (!(dimension instanceof Dimension)) {
            throw new Error('Composite() - Dimension value has to be of type GridDimension');
        }

        this.cell = cell;
        this.dimension = dimension;
        this.dimensionCell = new Cell(
            (cell.getRow() + dimension.getRows()) - 1,
            (cell.getColumn() + dimension.getColumns()) - 1,
        );
    }

    /**
     * @return {Cell}
     */
    getCell() {
        return this.cell;
    }

    /**
     * @return {Dimension}
     */
    getDimension() {
        return this.dimension;
    }

    /**
     * @return {Cell}
     */
    getDimensionCell() {
        return this.dimensionCell;
    }

    /**
     * @param {Cell} targetCell
     * @return {Composite}
     */
    moveToCell(targetCell) {
        const cellCopy = new Cell(targetCell.getRow(), targetCell.getColumn());
        const dimensionCopy = new Dimension(this.dimension.getRows(), this.dimension.getColumns());
        return new Composite(cellCopy, dimensionCopy);
    }

    getRatio() {
        return this.dimension.getRatio();
    }

    getArea() {
        return this.dimension.getRows() * this.dimension.getColumns();
    }
}
